import { timetableAPI } from '@/api'

export const changeLessonStatus = async (
  reportId: number,
  comment: string,
  status: string,
): Promise<boolean> => {
  try {
    const res = await timetableAPI.updateStatusComment({
      id: reportId,
      status: Number(status),
      comment: comment,
    })

    return res.data.status === 'success'
  } catch (error) {
    console.error('Ошибка changeLessonStatus:', error)
    return false
  }
}

export const changeLessonDuration = async (
  reportId: number,
  duration: number,
): Promise<boolean> => {
  try {
    const res = await timetableAPI.updateDuration({
      id: reportId,
      duration: duration || 0,
    })

    return res.data.status === 'success'
  } catch (error) {
    console.error('Ошибка changeLessonDuration:', error)
    return false
  }
}

export const changeLessonSalary = async (
  reportId: number,
  salaryOverride: number,
): Promise<boolean> => {
  try {
    const res = await timetableAPI.updateSalary({
      id: reportId,
      salary_override: salaryOverride,
    })

    return res.data.status === 'success'
  } catch (error) {
    console.error('Ошибка changeLessonSalary:', error)
    return false
  }
}
